import React from 'react'
import { Typography, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

export interface Props {
  installationId: number
  storageId: string | undefined
  owner: string
}

/**
 * Table component to show installation information in installation access request dialog.
 */
const InstallationAccessRequestDialogTable: React.FC<Props> = ({ installationId, storageId, owner }) => {
  const { t } = useCustomTranslation()

  return (
    <Table sx={{ '& td, & th': { padding: 0, border: 0, pr: 4, pb: 1 } }}>
      <TableHead>
        <TableRow>
          <TableCell sx={{ width: 0 }}>
            <Typography variant="subtitle2">{t('installation.overview.installation')}</Typography>
          </TableCell>
          <TableCell sx={{ width: 0 }}>
            <Typography variant="subtitle2">{t('administration.installations.serialNumber')}</Typography>
          </TableCell>
          <TableCell>
            <Typography variant="subtitle2">{t('installation.overview.owner')}</Typography>
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          <TableCell>
            <Typography variant="body2">{installationId}</Typography>
          </TableCell>
          <TableCell>
            <Typography variant="body2">{storageId}</Typography>
          </TableCell>
          <TableCell>
            <Typography variant="body2">{owner}</Typography>
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  )
}

export default InstallationAccessRequestDialogTable
